// Digest: 7783d7ef00709aafed096e707cc46409707f05bb
/* eslint-disable */
/// <reference types="vite/client.d.ts" />/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type ContainerSizeSubBlockOrNull = null | ContainerSizeSubBlock;
export type AlignedRichTextSubBlockOrNull = null | AlignedRichTextSubBlock;
export type RichTextBlockOrNull = null | RichTextBlock;
export type RichTextBlock = string;
export type _SlideListOrNull = null | _SlideList;
export type ImageChooserBlockOrNull = null | ImageChooserBlock;
export type _SlideList = _Slide[];
export type CharBlockOrNull = null | CharBlock;
export type CharBlock = string;
export type EmbedBlockOrNull = null | EmbedBlock;
export type EmbedBlock = string;
export type MediaChooserBlock = (
  | {
      type: "image";
      value: ImageChooserBlock;
      id: string;
    }
  | {
      type: "video";
      value: VideoChooserBlock;
      id: string;
    }
  | {
      type: "embed";
      value: MediaEmbedBlock;
      id: string;
    }
)[];
export type URLBlockOrNull = null | URLBlock;
export type URLBlock = string;
export type TableBlockOrNull = null | TableBlock;
export type TableBlock = string;
export type LabUIToolbox = (
  | {
      type: "alignedrichtextblock";
      value: AlignedRichTextBlock;
      id: string;
    }
  | {
      type: "gallerysubblock";
      value: GallerySubBlock;
      id: string;
    }
  | {
      type: "linksubblock";
      value: LinkSubBlock;
      id: string;
    }
  | {
      type: "mediachooserblock";
      value: MediaChooserBlock;
      id: string;
    }
  | {
      type: "scrollnavmenublock";
      value: ScrollNavMenuBlock;
      id: string;
    }
  | {
      type: "scrollnavmenuitemblock";
      value: ScrollNavMenuItemBlock;
      id: string;
    }
  | {
      type: "socialmediaicon";
      value: SocialMediaIcon;
      id: string;
    }
  | {
      type: "spacerblock";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "tableincontainerblock";
      value: TableInContainerBlock;
      id: string;
    }
  | {
      type: "onetrustprivacynoticeblock";
      value: OneTrustPrivacyNoticeBlock;
      id: string;
    }
  | {
      type: "videochooserblock";
      value: VideoChooserBlock;
      id: string;
    }
)[];
export type IntegerBlockOrNull = null | IntegerBlock;
export type IntegerBlock = number;
export type MediaGridBlockImageOrNull = null | MediaGridBlockImage;
export type MediaGridBlockColumnWidthOrNull = null | MediaGridBlockColumnWidth;
export type MediaGridBlockColumnWidth = "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | "10" | "11" | "12";
export type SimpleLinkBlockOrNull = null | SimpleLinkBlock;
export type BooleanBlockOrNull = null | BooleanBlock;
export type BooleanBlock = boolean;
export type AlignedRichTextBlockOrNull = null | AlignedRichTextBlock;
export type SitemapSectionListOrNull = null | SitemapSectionList;
export type SimpleLinkBlockListOrNull = null | SimpleLinkBlockList;
export type SimpleLinkBlockList = SimpleLinkBlock[];
export type SitemapSectionList = SitemapSection[];
export type CmsTieredNavOrNull = null | Cms;
export type _ArticleListOrNull = null | _ArticleList;
export type PageChooserBlockOrNull = null | PageChooserBlock;
export type DateTimeBlockOrNull = null | DateTimeBlock;
export type DateTimeBlock = string;
export type _ArticleList = _Article[];
export type _GridItemListOrNull = null | _GridItemList;
export type _GridItemList = _GridItem[];
export type VideoChooserBlockOrNull = null | VideoChooserBlock;
export type MediaGridBlock = (
  | {
      type: "image";
      value: MediaGridBlockImage;
      id: string;
    }
  | {
      type: "background_video";
      value: MediaGridBlockBackgroundVideo;
      id: string;
    }
  | {
      type: "video";
      value: MediaGridBlockVideo;
      id: string;
    }
)[];
export type ImageChooserBlockList = ImageChooserBlock[];
export type HeroBlockListOrNull = null | HeroBlockList;
export type HeroBlockList = HeroBlock[];
export type _ContentOrNull = null | _Content;
export type _AccordionFeatureListOrNull = null | _AccordionFeatureList;
export type _AccordionFeatureList = _AccordionFeature[];
export type _LinkRowItemListOrNull = null | _LinkRowItemList;
export type _LinkRowItemList = _LinkRowItem[];
export type MediaChooserBlockOrNull = null | MediaChooserBlock;
export type LinkSubBlockListOrNull = null | LinkSubBlockList;
export type LinkSubBlockList = LinkSubBlock[];
export type _Content = (
  | {
      type: "accordion_feature";
      value: AccordionFeatureBlock;
      id: string;
    }
  | {
      type: "artf";
      value: AlignedRichTextBlock;
      id: string;
    }
  | {
      type: "link_row";
      value: LinkRowBlock;
      id: string;
    }
  | {
      type: "two_column_feature";
      value: TwoColumnFeatureBlock;
      id: string;
    }
)[];
export type _FAQListOrNull = null | _FAQList;
export type _FAQList = _FAQ[];
export type FullWidthMediaBlock = {
  type: "hero";
  value: MediaChooserBlock;
  id: string;
}[];
export type FullWidthMediaBlockOrNull = null | FullWidthMediaBlock;
export type _GiftCardFeatureListOrNull = null | _GiftCardFeatureList;
export type _GiftCardFeatureList = _GiftCardFeature[];
export type _GiftCardCTAListOrNull = null | _GiftCardCTAList;
export type _GiftCardCTAList = _GiftCardCTA[];
export type _TabListOrNull = null | _TabList;
export type TwoColumnFeatureBlockListOrNull = null | TwoColumnFeatureBlockList;
export type TwoColumnFeatureBlockList = TwoColumnFeatureBlock[];
export type _TabList = _Tab[];
export type _EventListOrNull = null | _EventList;
export type _EventContentOrNull = null | _EventContent;
export type _EventContent = (
  | {
      type: "image";
      value: ImageChooserBlock;
      id: string;
    }
  | {
      type: "copy";
      value: RichTextBlock;
      id: string;
    }
)[];
export type _EventList = _Event[];
export type Toolbox = (
  | {
      type: "popup_modal";
      value: PopupModal;
      id: string;
    }
  | {
      type: "scroll_nav_menu_item";
      value: ScrollNavMenuItemBlock;
      id: string;
    }
  | {
      type: "sitemap";
      value: SitemapBlock;
      id: string;
    }
  | {
      type: "tiered_nav";
      value: TieredNavBlock;
      id: string;
    }
  | {
      type: "article_preview_grid";
      value: ArticlePreviewGridBlock;
      id: string;
    }
  | {
      type: "content_grid";
      value: ContentGridBlock;
      id: string;
    }
  | {
      type: "media_grid";
      value: MediaGridBlock;
      id: string;
    }
  | {
      type: "social_grid";
      value: ImageChooserBlockList;
      id: string;
    }
  | {
      type: "heading";
      value: HeadingBlock;
      id: string;
    }
  | {
      type: "hero";
      value: HeroBlock;
      id: string;
    }
  | {
      type: "two_column_hero";
      value: TwoColumnHeroBlock;
      id: string;
    }
  | {
      type: "custom_background_image_wrapper";
      value: CustomBackgroundImageWrapper;
      id: string;
    }
  | {
      type: "accordion_feature";
      value: AccordionFeatureBlock;
      id: string;
    }
  | {
      type: "alert";
      value: AlertBlock;
      id: string;
    }
  | {
      type: "artf";
      value: AlignedRichTextBlock;
      id: string;
    }
  | {
      type: "coupon";
      value: CouponBlock;
      id: string;
    }
  | {
      type: "faqs";
      value: FAQsBlock;
      id: string;
    }
  | {
      type: "feature_image";
      value: FeatureImageBlock;
      id: string;
    }
  | {
      type: "fresh_catch_feature";
      value: FreshCatchFeatureBlock;
      id: string;
    }
  | {
      type: "full_width_media";
      value: FullWidthMediaBlock;
      id: string;
    }
  | {
      type: "full_width_media_with_cta";
      value: FullWidthMediaWithCTABlock;
      id: string;
    }
  | {
      type: "gift_cards_feature";
      value: GiftCardsFeatureBlock;
      id: string;
    }
  | {
      type: "iframe";
      value: IFrameBlock;
      id: string;
    }
  | {
      type: "image_link";
      value: ImageLinkBlock;
      id: string;
    }
  | {
      type: "link_row";
      value: LinkRowBlock;
      id: string;
    }
  | {
      type: "table";
      value: TableInContainerBlock;
      id: string;
    }
  | {
      type: "tabbed_features";
      value: TabbedFeaturesBlock;
      id: string;
    }
  | {
      type: "timeline";
      value: TimelineBlock;
      id: string;
    }
  | {
      type: "two_column_feature";
      value: TwoColumnFeatureBlock;
      id: string;
    }
  | {
      type: "video_feature";
      value: VideoFeatureBlock;
      id: string;
    }
  | {
      type: "unsubscribe";
      value: UnsubscribeBlock;
      id: string;
    }
)[];
export type SocialMediaIconList = SocialMediaIcon[];
export type HeaderBlock = (
  | {
      type: "section";
      value: NavSection;
      id: string;
    }
  | {
      type: "social_media_row";
      value: SocialMediaIconList;
      id: string;
    }
)[];
export type FooterColumnContentOrNull = null | FooterColumnContent;
export type FooterColumnContent = (
  | {
      type: "link";
      value: SimpleLinkBlock;
      id: string;
    }
  | {
      type: "social_media_row";
      value: SocialMediaIconList;
      id: string;
    }
)[];
export type FooterColumnList = FooterColumn[];
export type FooterBlock = (
  | {
      type: "site_nav";
      value: FooterColumnList;
      id: string;
    }
  | {
      type: "region_nav";
      value: RegionNav;
      id: string;
    }
  | {
      type: "legal_text";
      value: RichTextBlock;
      id: string;
    }
)[];

export interface _Types {
  BasePageTemplateProps: ThelabuiModelsPagesBasePageBasePageTemplate;
  BaseFormPageTemplateProps: ThelabuiModelsPagesBaseFormPageBaseFormPageTemplate;
  BaseFormPageLandingPageTemplateProps: ThelabuiModelsPagesBaseFormPageBaseFormPageLandingPageTemplate;
  ExamplePageTemplateProps: ThelabuiModelsPagesExamplePageExamplePageTemplate;
  LabUIToolboxSnippetPreviewProps: ThelabuiModelsSnippetsToolboxSnippetLabUIToolboxSnippetPreview;
  ContactUsPageTemplateProps: ServerCmsModelsPagesContactUsPageContactUsPageTemplate;
  ContactUsPageLandingPageTemplateProps: ServerCmsModelsPagesContactUsPageContactUsPageLandingPageTemplate;
  LocationsPageMapTemplateProps: ServerCmsModelsPagesLocationsPageLocationsPageMapTemplate;
  EmailSignupPageTemplateProps: ServerCmsModelsPagesEmailSignupPageEmailSignupPageTemplate;
  EmailSignupPageLandingPageTemplateProps: ServerCmsModelsPagesEmailSignupPageEmailSignupPageLandingPageTemplate;
  HomePageTemplateProps: ServerCmsModelsPagesHomePageHomePageTemplate;
  LocationsPageStateListTemplateProps: ServerCmsModelsPagesLocationsDirectoryPageLocationsPageStateListTemplate;
  LocationsPageLocationListTemplateProps: ServerCmsModelsPagesLocationsDirectoryPageLocationsPageLocationListTemplate;
  LocationsPageLocationTemplateProps: ServerCmsModelsPagesLocationsDirectoryPageLocationsPageLocationTemplate;
  PressReleasePageTemplateProps: ServerCmsModelsPagesPressReleasePagePressReleasePageTemplate;
  PressReleaseListPageTemplateProps: ServerCmsModelsPagesPressReleaseListPagePressReleaseListPageTemplate;
  PressSectionPageTemplateProps: ServerCmsModelsPagesPressSectionPagePressSectionPageTemplate;
  RedirectPageTemplateProps: ServerCmsModelsPagesRedirectPageRedirectPageTemplate;
  UtilityPageTemplateProps: ServerCmsModelsPagesUtilityPageUtilityPageTemplate;
  LabUIIncludeReactContextTemplateProps: ThelabuiTemplatetagsThelabuiTagsLabUIIncludeReactContextTemplate;
  FooterTemplateProps: ServerCmsViewsFooterTemplate;
  Error404TemplateProps: ServerViewsError404Template;
  globals: {
    Widget:
      | DjangoFormsWidgetsTextInput
      | DjangoFormsWidgetsHiddenInput
      | DjangoFormsWidgetsSelect
      | DjangoFormsWidgetsSelectDateWidget
      | DjangoFormsWidgetsEmailInput
      | PhonenumberFieldWidgetsRegionalPhoneNumberWidget
      | DjangoFormsWidgetsTextarea
      | ServerCmsFormsReCaptchaV2Checkbox
      | DjangoFormsWidgetsCheckboxInput;
    models: {
      "cms.models.pages.locations_directory_page.LocationsDirectoryPageData": CmsModelsPagesLocationsDirectoryPageLocationsDirectoryPageData;
      "cms.models.pages.press_utils.PressReleaseTile": CmsModelsPagesPressUtilsPressReleaseTile;
      "cms.models.pages.press_utils.SeeAllLink": CmsModelsPagesPressUtilsSeeAllLink;
    };
  };
  Context: ReactivatedSerializationContextProcessorsBaseContext &
    ReactivatedSerializationContextProcessorsMessagesProcessor &
    ReactivatedSerializationContextProcessorsCSRFProcessor &
    ReactivatedSerializationContextProcessorsRequestProcessor &
    ReactivatedSerializationContextProcessorsStaticProcessor &
    ThelabuiContextProcessorsTranslationProcessor &
    ServerCmsContextProcessorsCoreAssetProcessor &
    ServerCmsContextProcessorsSettingsProcessor &
    ServerCmsContextProcessorsNavigationProcessor;
  RPCPermission: null;
}
export interface ThelabuiModelsPagesBasePageBasePageTemplate {
  is_preview: boolean;
  page: BasePageEb66F00405;
}
export interface BasePageEb66F00405 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
}
export interface ThelabuiTypesLanguage {
  code: string;
  vernacular_name: string;
  translated_name: string;
  dir: "ltr" | "rtl" | "auto";
}
export interface ThelabuiTypesAlternatePage {
  title: string;
  url: string;
  language: ThelabuiTypesLanguage;
}
export interface ThelabuiModelsPagesBaseFormPageBaseFormPageTemplate {
  is_preview: boolean;
  page: BaseFormPageFe4F84D43A;
  form: DjangoFormsForms;
}
export interface BaseFormPageFe4F84D43A {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
}
export interface DjangoFormsForms {
  name: "django.forms.forms.Form";
  errors: {} | null;
  fields: {};
  prefix: string;
  iterator: [];
  hidden_fields?: [];
}
export interface ThelabuiModelsPagesBaseFormPageBaseFormPageLandingPageTemplate {
  is_preview: boolean;
  page: BaseFormPageFe4F84D43A;
}
export interface ThelabuiModelsPagesExamplePageExamplePageTemplate {
  is_preview: boolean;
  page: ExamplePage_8C9639Cb8F;
}
export interface ExamplePage_8C9639Cb8F {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  image: {
    block: ThelabuiSerializationImagesImageBlockValue;
  } | null;
  image_tile: {
    renditions_webp: WagtailImageRendition[];
  } | null;
  richtext: RichTextField;
  body: ThelabuiExamplePage;
  snippets: {
    body: ThelabuiLabUIToolboxSnippet;
  }[];
  attachment: {
    title: string;
    created_at: string;
    file_size: number | null;
    file_hash: string;
    filename: string;
    file_extension: string;
    url: string;
    content_type: string;
    content_disposition: string;
    file: FileField;
    tags: {
      name: string;
    }[];
  } | null;
}
export interface ThelabuiSerializationImagesImageBlockValue {
  title: string;
  description: string;
  default_alt_text: string;
  width: number;
  height: number;
  brightness: number | null;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
  imageData: string | null;
}
export interface ThelabuiSerializationImagesImageRenditionBlockValue {
  spec: string;
  width: number;
  height: number;
  url: string;
  size: number;
  mimetype: string;
}
export interface WagtailImageRendition {
  spec: string;
  width: number;
  height: number;
  url: string;
  size: number;
  mimetype: string;
}
export interface RichTextField {
  _type: "RichTextField";
  html: string;
}
export interface ThelabuiExamplePage {
  _type: "StreamField";
  _variant: "thelabui.ExamplePage.body";
  value: LabUIToolbox;
  [k: string]: unknown;
}
export interface AlignedRichTextBlock {
  container?: ContainerSizeSubBlockOrNull;
  content?: AlignedRichTextSubBlockOrNull;
  layout: null | ("full-width" | "centered" | "left-aligned");
}
export interface ContainerSizeSubBlock {
  width?: null | ("" | "full" | "twoThirds" | "half");
}
export interface AlignedRichTextSubBlock {
  content?: RichTextBlockOrNull;
  alignment?: null | ("" | "textAlignCenter" | "textAlignRight");
}
export interface GallerySubBlock {
  slides?: _SlideListOrNull;
}
export interface _Slide {
  image: ImageChooserBlockOrNull;
  caption?: AlignedRichTextSubBlockOrNull;
}
export interface ImageChooserBlock {
  title: string;
  description: string;
  default_alt_text: string;
  width: number;
  height: number;
  brightness: null | number;
  url: string;
  renditions: {
    /**
     * This interface was referenced by `undefined`'s JSON-Schema definition
     * via the `patternProperty` "^.*$".
     */
    [k: string]: {
      spec: string;
      width: number;
      height: number;
      url: string;
      size: number;
      mimetype: string;
    };
  };
  imageData: null | string;
}
export interface LinkSubBlock {
  display_name?: CharBlockOrNull;
  link_type?: null | ("page" | "external" | "email" | "document");
  anchor?: CharBlockOrNull;
  link_style?: null | ("" | "secondary" | "text-link");
  url: null | string;
}
export interface VideoChooserBlock {
  poster: null | string;
  sources: {
    url: string;
    mimetype: string;
  }[];
  title: string;
  tracks: {
    kind: string;
    kind_name: string;
    src: string;
    label: string;
    srclang: string;
    srclang_name: null | string;
    sort_order: number;
  }[];
  width: null | number;
  height: null | number;
  aspectRatio: null | number;
}
export interface MediaEmbedBlock {
  title: CharBlockOrNull;
  thumbnail: ImageChooserBlockOrNull;
  embed: EmbedBlockOrNull;
}
export interface ScrollNavMenuBlock {}
export interface ScrollNavMenuItemBlock {
  name: CharBlockOrNull;
}
export interface SocialMediaIcon {
  icon: null | ("facebook" | "instagram" | "linkedin" | "pinterest" | "tiktok" | "twitter" | "youtube");
  link: URLBlockOrNull;
}
export interface SpacerBlock {
  anchor?: CharBlockOrNull;
  height: null | ("no-height" | "small" | "medium" | "large" | "xlarge" | "xxlarge");
}
export interface TableInContainerBlock {
  container?: ContainerSizeSubBlockOrNull;
  table: TableBlockOrNull;
}
export interface OneTrustPrivacyNoticeBlock {
  script_url: URLBlockOrNull;
  callback_url: URLBlockOrNull;
  notice_url: URLBlockOrNull;
}
export interface ThelabuiLabUIToolboxSnippet {
  _type: "StreamField";
  _variant: "thelabui.LabUIToolboxSnippet.body";
  value: LabUIToolbox;
  [k: string]: unknown;
}
export interface FileField {
  url: string;
}
export interface ThelabuiModelsSnippetsToolboxSnippetLabUIToolboxSnippetPreview {
  object: LabUIToolboxSnippetFdc2906E1B;
}
export interface LabUIToolboxSnippetFdc2906E1B {
  id: number;
  name: string;
  body: ThelabuiLabUIToolboxSnippet;
}
export interface ServerCmsModelsPagesContactUsPageContactUsPageTemplate {
  is_preview: boolean;
  page: ContactUsPage_569E991B43;
  form: ServerCmsForms;
}
export interface ContactUsPage_569E991B43 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  background_style: string;
  body: CmsContactUsPage;
}
export interface CmsContactUsPage {
  _type: "StreamField";
  _variant: "cms.ContactUsPage.body";
  value: Toolbox;
  [k: string]: unknown;
}
export interface PopupModal {
  delay_seconds: IntegerBlockOrNull;
  content?: MediaGridBlockImageOrNull;
}
export interface MediaGridBlockImage {
  alt_text: CharBlockOrNull;
  desktop_image: ImageChooserBlockOrNull;
  desktop_width: MediaGridBlockColumnWidthOrNull;
  mobile_image: ImageChooserBlockOrNull;
  mobile_width: MediaGridBlockColumnWidthOrNull;
  link?: SimpleLinkBlockOrNull;
  text_style: null | ("light" | "dark");
  fineprint_width: MediaGridBlockColumnWidthOrNull;
  fineprint_dropshadow?: BooleanBlockOrNull;
  fineprint?: AlignedRichTextBlockOrNull;
}
export interface SimpleLinkBlock {
  display_name?: CharBlockOrNull;
  link_type?: null | ("page" | "external" | "email" | "document");
  anchor?: CharBlockOrNull;
  url: null | string;
}
export interface SitemapBlock {
  title: CharBlockOrNull;
  sections?: SitemapSectionListOrNull;
}
export interface SitemapSection {
  title: CharBlockOrNull;
  links?: SimpleLinkBlockListOrNull;
}
export interface TieredNavBlock {
  tiered_nav: CmsTieredNavOrNull;
}
export interface Cms {
  root_page: {
    id: number;
    url: string;
    title: string;
  };
  tier_one_links: {
    id: number;
    url: string;
    title: string;
  }[];
  tier_two_links: {
    parent: {
      id: number;
      url: string;
      title: string;
    };
    links: {
      id: number;
      url: string;
      title: string;
    }[];
  }[];
}
export interface ArticlePreviewGridBlock {
  articles?: _ArticleListOrNull;
  see_all_link?: PageChooserBlockOrNull;
}
export interface _Article {
  link: PageChooserBlockOrNull;
  image: ImageChooserBlockOrNull;
  date: DateTimeBlockOrNull;
  title: CharBlockOrNull;
}
export interface PageChooserBlock {
  id: number;
  url: string;
  title: string;
}
export interface ContentGridBlock {
  items?: _GridItemListOrNull;
}
export interface _GridItem {
  image?: ImageChooserBlockOrNull;
  content: RichTextBlockOrNull;
}
export interface MediaGridBlockBackgroundVideo {
  desktop_video: VideoChooserBlockOrNull;
  desktop_width: MediaGridBlockColumnWidthOrNull;
  desktop_file_width: IntegerBlockOrNull;
  desktop_file_height: IntegerBlockOrNull;
  mobile_video: VideoChooserBlockOrNull;
  mobile_width: MediaGridBlockColumnWidthOrNull;
  mobile_file_width: IntegerBlockOrNull;
  mobile_file_height: IntegerBlockOrNull;
  link?: SimpleLinkBlockOrNull;
  text_style: null | ("light" | "dark");
  fineprint_width: MediaGridBlockColumnWidthOrNull;
  fineprint_dropshadow?: BooleanBlockOrNull;
  fineprint?: AlignedRichTextBlockOrNull;
}
export interface MediaGridBlockVideo {
  caption: CharBlockOrNull;
  video: VideoChooserBlockOrNull;
  desktop_width: MediaGridBlockColumnWidthOrNull;
  mobile_width: MediaGridBlockColumnWidthOrNull;
}
export interface HeadingBlock {
  heading_text: CharBlockOrNull;
  size: null | ("h2" | "h3" | "h4");
  style: null | "rope";
}
export interface HeroBlock {
  image: ImageChooserBlockOrNull;
  image_alignment: null | ("align-left" | "align-center" | "align-right");
  text_style: null | ("light" | "dark");
  title: CharBlockOrNull;
  subtitle?: CharBlockOrNull;
  link?: PageChooserBlockOrNull;
  link_text?: CharBlockOrNull;
}
export interface TwoColumnHeroBlock {
  columns?: HeroBlockListOrNull;
}
export interface CustomBackgroundImageWrapper {
  background_image: ImageChooserBlockOrNull;
  mobile_background_image?: ImageChooserBlockOrNull;
  text_style: null | ("light" | "dark");
  content: _ContentOrNull;
}
export interface AccordionFeatureBlock {
  image?: ImageChooserBlockOrNull;
  accordions?: _AccordionFeatureListOrNull;
}
export interface _AccordionFeature {
  default_content: RichTextBlockOrNull;
  hidden_content: RichTextBlockOrNull;
}
export interface LinkRowBlock {
  heading: CharBlockOrNull;
  links?: _LinkRowItemListOrNull;
  fineprint?: CharBlockOrNull;
}
export interface _LinkRowItem {
  link?: SimpleLinkBlockOrNull;
  image: ImageChooserBlockOrNull;
}
export interface TwoColumnFeatureBlock {
  column_layout: null | ("media-left" | "media-right");
  media?: MediaChooserBlockOrNull;
  media_caption?: CharBlockOrNull;
  media_alignment: null | ("align-left" | "align-center" | "align-right");
  content?: AlignedRichTextBlockOrNull;
  links?: LinkSubBlockListOrNull;
}
export interface AlertBlock {
  background_style:
    | null
    | ("wood-texture" | "lighthouse" | "faded-shoreline" | "military-monday" | "lobster" | "blue-chill");
  content: RichTextBlockOrNull;
}
export interface CouponBlock {
  coupon: ImageChooserBlockOrNull;
  expires_on?: CharBlockOrNull;
}
export interface FAQsBlock {
  heading: RichTextBlockOrNull;
  layout: null | ("one-column" | "two-column");
  faqs?: _FAQListOrNull;
}
export interface _FAQ {
  question: CharBlockOrNull;
  answer: RichTextBlockOrNull;
}
export interface FeatureImageBlock {
  width: null | ("centered" | "full-width");
  image: ImageChooserBlockOrNull;
}
export interface FreshCatchFeatureBlock {
  link?: SimpleLinkBlockOrNull;
}
export interface FullWidthMediaWithCTABlock {
  media: FullWidthMediaBlockOrNull;
  mobile_media?: FullWidthMediaBlockOrNull;
  max_height: CharBlockOrNull;
  cta?: SimpleLinkBlockOrNull;
  text_style: null | ("light" | "dark");
  fineprint_width: MediaGridBlockColumnWidthOrNull;
  fineprint_dropshadow?: BooleanBlockOrNull;
  fineprint?: AlignedRichTextBlockOrNull;
}
export interface GiftCardsFeatureBlock {
  card_features?: _GiftCardFeatureListOrNull;
  ctas?: _GiftCardCTAListOrNull;
}
export interface _GiftCardFeature {
  image: ImageChooserBlockOrNull;
  content: RichTextBlockOrNull;
}
export interface _GiftCardCTA {
  heading: CharBlockOrNull;
  cta?: SimpleLinkBlockOrNull;
}
export interface IFrameBlock {
  url: URLBlockOrNull;
  mobile_url?: URLBlockOrNull;
  default_height: IntegerBlockOrNull;
}
export interface ImageLinkBlock {
  image: ImageChooserBlockOrNull;
  link?: SimpleLinkBlockOrNull;
}
export interface TabbedFeaturesBlock {
  header_content?: AlignedRichTextBlockOrNull;
  tabs?: _TabListOrNull;
}
export interface _Tab {
  tab_name: CharBlockOrNull;
  content?: TwoColumnFeatureBlockListOrNull;
}
export interface TimelineBlock {
  layout: null | ("full-width" | "centered" | "left-aligned");
  header?: RichTextBlockOrNull;
  events?: _EventListOrNull;
  footer?: RichTextBlockOrNull;
}
export interface _Event {
  year: CharBlockOrNull;
  content: _EventContentOrNull;
}
export interface VideoFeatureBlock {
  image: ImageChooserBlockOrNull;
  image_alignment: null | ("align-left" | "align-center" | "align-right");
  text_style: null | ("light" | "dark");
  title: CharBlockOrNull;
  subtitle?: CharBlockOrNull;
  link?: PageChooserBlockOrNull;
  link_text?: CharBlockOrNull;
  video: VideoChooserBlockOrNull;
  show_share_icons?: BooleanBlockOrNull;
  facebook_url?: CharBlockOrNull;
  twitter_url?: CharBlockOrNull;
  fineprint?: CharBlockOrNull;
}
export interface UnsubscribeBlock {}
export interface ServerCmsForms {
  name: "server.cms.forms.ContactUsForm";
  errors: {
    question_category?: string[];
    topic?: string[];
    location_rlid?: string[];
    visit_date?: string[];
    visit_time?: string[];
    order_number?: string[];
    first_name?: string[];
    last_name?: string[];
    email?: string[];
    phone?: string[];
    address_line1?: string[];
    address_city?: string[];
    address_state?: string[];
    address_zip?: string[];
    message?: string[];
    captcha?: string[];
  } | null;
  fields: {
    question_category: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    topic: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    location_rlid: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsHiddenInput;
    } & {};
    visit_date: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsSelectDateWidget;
    } & {};
    visit_time: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsSelect;
    } & {};
    order_number: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    first_name: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    last_name: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    email: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsEmailInput;
    } & {};
    phone: ReactivatedSerializationFieldType & {
      widget: PhonenumberFieldWidgetsRegionalPhoneNumberWidget;
    } & {};
    address_line1: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    address_city: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    address_state: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    address_zip: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    message: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextarea;
    } & {};
    captcha: ReactivatedSerializationFieldType & {
      widget: ServerCmsFormsReCaptchaV2Checkbox;
    } & {};
  };
  prefix: string;
  iterator: (
    | "question_category"
    | "topic"
    | "location_rlid"
    | "visit_date"
    | "visit_time"
    | "order_number"
    | "first_name"
    | "last_name"
    | "email"
    | "phone"
    | "address_line1"
    | "address_city"
    | "address_state"
    | "address_zip"
    | "message"
    | "captcha"
  )[];
  hidden_fields?: (
    | "question_category"
    | "topic"
    | "location_rlid"
    | "visit_date"
    | "visit_time"
    | "order_number"
    | "first_name"
    | "last_name"
    | "email"
    | "phone"
    | "address_line1"
    | "address_city"
    | "address_state"
    | "address_zip"
    | "message"
    | "captcha"
  )[];
}
export interface ReactivatedSerializationFieldType {
  name: string;
  label: string;
  help_text: string | null;
}
export interface DjangoFormsWidgetsTextInput {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsMaxLengthAttrs;
  type: "text";
  tag: "django.forms.widgets.TextInput";
}
export interface ReactivatedSerializationWidgetsMaxLengthAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  maxlength?: string;
}
export interface DjangoFormsWidgetsHiddenInput {
  template_name: "django/forms/widgets/hidden.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsBaseWidgetAttrs;
  type: "hidden";
  tag: "django.forms.widgets.HiddenInput";
}
export interface ReactivatedSerializationWidgetsBaseWidgetAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}
export interface DjangoFormsWidgetsSelectDateWidget {
  template_name: "django/forms/widgets/select_date.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: unknown;
  attrs: ReactivatedSerializationWidgetsBaseWidgetAttrs;
  _reactivated_value_do_not_use?: {
    year: string | null;
    month: string | null;
    day: string | null;
  };
  /**
   * @minItems 3
   * @maxItems 3
   */
  subwidgets: [DjangoFormsWidgetsSelect, DjangoFormsWidgetsSelect, DjangoFormsWidgetsSelect];
  tag: "django.forms.widgets.SelectDateWidget";
}
export interface DjangoFormsWidgetsSelect {
  template_name: "django/forms/widgets/select.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsBaseWidgetAttrs;
  optgroups: [null, [ReactivatedSerializationWidgetsOptgroupMember], number][];
  tag: "django.forms.widgets.Select";
}
export interface ReactivatedSerializationWidgetsOptgroupMember {
  name: string;
  value: string | number | boolean | null;
  label: string;
  selected: boolean;
}
export interface DjangoFormsWidgetsEmailInput {
  template_name: "django/forms/widgets/email.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsBaseWidgetAttrs;
  type: "email";
  tag: "django.forms.widgets.EmailInput";
}
export interface PhonenumberFieldWidgetsRegionalPhoneNumberWidget {
  template_name: "django/forms/widgets/text.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsMaxLengthAttrs;
  type: "text";
  tag: "phonenumber_field.widgets.RegionalPhoneNumberWidget";
}
export interface DjangoFormsWidgetsTextarea {
  template_name: "django/forms/widgets/textarea.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsTextareaAttrs;
  tag: "django.forms.widgets.Textarea";
}
export interface ReactivatedSerializationWidgetsTextareaAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  cols: string;
  rows: string;
}
export interface ServerCmsFormsReCaptchaV2Checkbox {
  template_name: "django_recaptcha/widget_v2_checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: string | null;
  attrs: ReactivatedSerializationWidgetsBaseWidgetAttrs;
  type: "hidden";
  public_key: string;
  widget_uuid: string;
  api_params: string;
  recaptcha_domain: string;
  callback_name: string;
  size: string;
  tag: "server.cms.forms.ReCaptchaV2Checkbox";
}
export interface ServerCmsModelsPagesContactUsPageContactUsPageLandingPageTemplate {
  is_preview: boolean;
  page: ContactUsPage_2Bbea593F4;
}
export interface ContactUsPage_2Bbea593F4 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  background_style: string;
  body: CmsContactUsPage;
  confirmation_content: CmsContactUsPage1;
}
export interface CmsContactUsPage1 {
  _type: "StreamField";
  _variant: "cms.ContactUsPage.confirmation_content";
  value: Toolbox;
  [k: string]: unknown;
}
export interface ServerCmsModelsPagesLocationsPageLocationsPageMapTemplate {
  page: LocationsPage_4A2A26D79E;
}
export interface LocationsPage_4A2A26D79E {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  country: {
    iso_3166_1_a2: string;
    printable_name: string;
    name: string;
  };
  url: string;
}
export interface ServerCmsModelsPagesEmailSignupPageEmailSignupPageTemplate {
  is_preview: boolean;
  page: EmailSignupPage_8Ea9Cccac2;
  form: ServerCmsForms1;
  occasion_formset: ReactivatedSerializationFormSetType;
}
export interface EmailSignupPage_8Ea9Cccac2 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  background_style: string;
  body: CmsEmailSignupPage;
  pre_form_content: CmsEmailSignupPage1;
  terms_page: {
    id: number;
    url: string;
    title: string;
  };
  privacy_page: {
    id: number;
    url: string;
    title: string;
  };
  faq_page: {
    id: number;
    url: string;
    title: string;
  };
  unsubscribe_page: {
    id: number;
    url: string;
    title: string;
  };
  consent_text: string;
  post_consent_text: RichTextField;
  footer_text: RichTextField;
}
export interface CmsEmailSignupPage {
  _type: "StreamField";
  _variant: "cms.EmailSignupPage.body";
  value: Toolbox;
  [k: string]: unknown;
}
export interface CmsEmailSignupPage1 {
  _type: "StreamField";
  _variant: "cms.EmailSignupPage.pre_form_content";
  value: Toolbox;
  [k: string]: unknown;
}
export interface ServerCmsForms1 {
  name: "server.cms.forms.EmailSignupForm";
  errors: {
    first_name?: string[];
    last_name?: string[];
    email?: string[];
    postcode?: string[];
    birthday_month?: string[];
    birthday_day?: string[];
    terms?: string[];
    consent?: string[];
    captcha?: string[];
  } | null;
  fields: {
    first_name: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    last_name: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    email: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsEmailInput;
    } & {};
    postcode: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsTextInput;
    } & {};
    birthday_month: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsSelect;
    } & {};
    birthday_day: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsSelect;
    } & {};
    terms: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsCheckboxInput;
    } & {};
    consent: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsCheckboxInput;
    } & {};
    captcha: ReactivatedSerializationFieldType & {
      widget: ServerCmsFormsReCaptchaV2Checkbox;
    } & {};
  };
  prefix: string;
  iterator: (
    | "first_name"
    | "last_name"
    | "email"
    | "postcode"
    | "birthday_month"
    | "birthday_day"
    | "terms"
    | "consent"
    | "captcha"
  )[];
  hidden_fields?: (
    | "first_name"
    | "last_name"
    | "email"
    | "postcode"
    | "birthday_month"
    | "birthday_day"
    | "terms"
    | "consent"
    | "captcha"
  )[];
}
export interface DjangoFormsWidgetsCheckboxInput {
  template_name: "django/forms/widgets/checkbox.html";
  name: string;
  is_hidden: boolean;
  required: boolean;
  value: boolean;
  attrs: ReactivatedSerializationWidgetsCheckAttrs;
  type: "checkbox";
  tag: "django.forms.widgets.CheckboxInput";
}
export interface ReactivatedSerializationWidgetsCheckAttrs {
  id: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  checked?: boolean;
}
export interface ReactivatedSerializationFormSetType {
  initial_form_count: number;
  total_form_count: number;
  max_num: number;
  min_num: number;
  can_delete: boolean;
  can_order: boolean;
  non_form_errors: string[];
  prefix: string;
  empty_form: ServerCmsForms2;
  forms: ServerCmsForms2[];
  management_form: DjangoFormsFormsets;
}
export interface ServerCmsForms2 {
  name: "server.cms.forms.OccasionForm";
  errors: {
    occasion?: string[];
    relationship?: string[];
    month?: string[];
    day?: string[];
  } | null;
  fields: {
    occasion: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsSelect;
    } & {};
    relationship: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsSelect;
    } & {};
    month: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsSelect;
    } & {};
    day: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsSelect;
    } & {};
  };
  prefix: string;
  iterator: ("occasion" | "relationship" | "month" | "day")[];
  hidden_fields?: ("occasion" | "relationship" | "month" | "day")[];
}
export interface DjangoFormsFormsets {
  name: "django.forms.formsets.ManagementForm";
  errors: {
    TOTAL_FORMS?: string[];
    INITIAL_FORMS?: string[];
    MIN_NUM_FORMS?: string[];
    MAX_NUM_FORMS?: string[];
  } | null;
  fields: {
    TOTAL_FORMS: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsHiddenInput;
    } & {};
    INITIAL_FORMS: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsHiddenInput;
    } & {};
    MIN_NUM_FORMS: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsHiddenInput;
    } & {};
    MAX_NUM_FORMS: ReactivatedSerializationFieldType & {
      widget: DjangoFormsWidgetsHiddenInput;
    } & {};
  };
  prefix: string;
  iterator: ("TOTAL_FORMS" | "INITIAL_FORMS" | "MIN_NUM_FORMS" | "MAX_NUM_FORMS")[];
  hidden_fields?: ("TOTAL_FORMS" | "INITIAL_FORMS" | "MIN_NUM_FORMS" | "MAX_NUM_FORMS")[];
}
export interface ServerCmsModelsPagesEmailSignupPageEmailSignupPageLandingPageTemplate {
  is_preview: boolean;
  page: EmailSignupPage_57202001Aa;
}
export interface EmailSignupPage_57202001Aa {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  background_style: string;
  body: CmsEmailSignupPage;
  confirmation_content: CmsEmailSignupPage2;
  faq_page: {
    id: number;
    url: string;
    title: string;
  };
  unsubscribe_page: {
    id: number;
    url: string;
    title: string;
  };
  consent_text: string;
  post_consent_text: RichTextField;
  footer_text: RichTextField;
}
export interface CmsEmailSignupPage2 {
  _type: "StreamField";
  _variant: "cms.EmailSignupPage.confirmation_content";
  value: Toolbox;
  [k: string]: unknown;
}
export interface ServerCmsModelsPagesHomePageHomePageTemplate {
  is_preview: boolean;
  page: HomePageCabd79F78C;
}
export interface HomePageCabd79F78C {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  body: CmsHomePage;
}
export interface CmsHomePage {
  _type: "StreamField";
  _variant: "cms.HomePage.body";
  value: Toolbox;
  [k: string]: unknown;
}
export interface ServerCmsModelsPagesLocationsDirectoryPageLocationsPageStateListTemplate {
  page: CmsModelsPagesLocationsDirectoryPageLocationsDirectoryPageData;
  other_directories: CmsModelsPagesLocationsDirectoryPageLocationsDirectoryPageData[];
  states: ServerCmsModelsPagesLocationsDirectoryPageState[];
}
export interface CmsModelsPagesLocationsDirectoryPageLocationsDirectoryPageData {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  country: {
    iso_3166_1_a2: string;
    printable_name: string;
    name: string;
  };
  url: string;
}
export interface ServerCmsModelsPagesLocationsDirectoryPageState {
  slug: string;
  name: string;
  cities: ServerCmsModelsPagesLocationsDirectoryPageCity[];
}
export interface ServerCmsModelsPagesLocationsDirectoryPageCity {
  name: string;
  slug: string;
  url: string;
}
export interface ServerCmsModelsPagesLocationsDirectoryPageLocationsPageLocationListTemplate {
  page: CmsModelsPagesLocationsDirectoryPageLocationsDirectoryPageData;
  state_list_url: string;
  state_code: string;
  city_name: string;
  locations: ServerCmsModelsPagesLocationsDirectoryPageLocation[];
}
export interface ServerCmsModelsPagesLocationsDirectoryPageLocation {
  id: number;
  rlid: number;
  name: string;
  phone: ServerCmsModelsPagesLocationsDirectoryPagePhone | null;
  location: ServerCmsModelsPagesLocationsDirectoryPageCoodinates | null;
  line1: string;
  line2: string;
  city: string;
  state: string;
  country: string;
  countryRootURL: string;
  postcode: string;
  line1_slug: string;
  city_slug: string;
  url: string;
  hours: ServerCmsModelsPagesLocationsDirectoryPageOperatingHours[];
  map_image_url_mobile: string;
  map_image_url_desktop: string;
  has_online_ordering: boolean;
}
export interface ServerCmsModelsPagesLocationsDirectoryPagePhone {
  national: string;
  e164: string;
}
export interface ServerCmsModelsPagesLocationsDirectoryPageCoodinates {
  lng: number;
  lat: number;
}
export interface ServerCmsModelsPagesLocationsDirectoryPageOperatingHours {
  type_name: string;
  days: ServerCmsModelsPagesLocationsDirectoryPageDayOperatingHours[];
}
export interface ServerCmsModelsPagesLocationsDirectoryPageDayOperatingHours {
  day_name: string;
  hours: string[];
}
export interface ServerCmsModelsPagesLocationsDirectoryPageLocationsPageLocationTemplate {
  page: CmsModelsPagesLocationsDirectoryPageLocationsDirectoryPageData;
  location: ServerCmsModelsPagesLocationsDirectoryPageLocation;
}
export interface ServerCmsModelsPagesPressReleasePagePressReleasePageTemplate {
  is_preview: boolean;
  page: PressReleasePage_4E4B271995;
}
export interface PressReleasePage_4E4B271995 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  date: string;
  copy: RichTextField;
  press_section: ServerCmsModelsPagesMixinsPressSection | null;
}
export interface ServerCmsModelsPagesMixinsPressSection {
  id: number;
  title: string;
  url: string;
}
export interface ServerCmsModelsPagesPressReleaseListPagePressReleaseListPageTemplate {
  is_preview: boolean;
  page: PressReleaseListPageE37Fbf56D8;
  press_releases: ServerCmsModelsPagesPressUtilsPressReleases;
}
export interface PressReleaseListPageE37Fbf56D8 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  url: string;
  press_section: ServerCmsModelsPagesMixinsPressSection | null;
}
export interface ServerCmsModelsPagesPressUtilsPressReleases {
  num_pages: number;
  current_page: number;
  next_page: number | null;
  prev_page: number | null;
  articles: CmsModelsPagesPressUtilsPressReleaseTile[];
  see_all_link: CmsModelsPagesPressUtilsSeeAllLink | null;
}
export interface CmsModelsPagesPressUtilsPressReleaseTile {
  id: number;
  title: string;
  date: string;
  feature_image: {
    block: ThelabuiSerializationImagesImageBlockValue1;
  } | null;
  url: string;
}
export interface ThelabuiSerializationImagesImageBlockValue1 {
  title: string;
  description: string;
  default_alt_text: string;
  width: number;
  height: number;
  brightness: number | null;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
  imageData: string | null;
}
export interface CmsModelsPagesPressUtilsSeeAllLink {
  id: number;
  title: string;
  url: string;
}
export interface ServerCmsModelsPagesPressSectionPagePressSectionPageTemplate {
  is_preview: boolean;
  page: PressSectionPage_154360Db04;
  press_releases: ServerCmsModelsPagesPressUtilsPressReleases;
}
export interface PressSectionPage_154360Db04 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  url: string;
  contact_info: RichTextField;
  media_download_tiles: ServerCmsModelsPagesPressSectionPageMediaDownloadTile[];
}
export interface ServerCmsModelsPagesPressSectionPageMediaDownloadTile {
  title: string;
  image: ThelabuiSerializationImagesImageBlockValue2;
  filename: string;
  file_extension: string;
  file_size: number;
  url: string;
}
export interface ThelabuiSerializationImagesImageBlockValue2 {
  title: string;
  description: string;
  default_alt_text: string;
  width: number;
  height: number;
  brightness: number | null;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
  imageData: string | null;
}
export interface ServerCmsModelsPagesRedirectPageRedirectPageTemplate {
  is_preview: boolean;
  page: RedirectPageD4Ae0C1C6C;
}
export interface RedirectPageD4Ae0C1C6C {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
}
export interface ServerCmsModelsPagesUtilityPageUtilityPageTemplate {
  is_preview: boolean;
  page: UtilityPage_99E1Bfb0Bc;
}
export interface UtilityPage_99E1Bfb0Bc {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  background_style: string;
  body: CmsUtilityPage;
}
export interface CmsUtilityPage {
  _type: "StreamField";
  _variant: "cms.UtilityPage.body";
  value: Toolbox;
  [k: string]: unknown;
}
export interface ThelabuiTemplatetagsThelabuiTagsLabUIIncludeReactContextTemplate {}
export interface ServerCmsViewsFooterTemplate {
  title: string;
}
export interface ServerViewsError404Template {
  title: string;
}
export interface ReactivatedSerializationContextProcessorsBaseContext {
  template_name: string;
}
export interface ReactivatedSerializationContextProcessorsMessagesProcessor {
  messages: ReactivatedSerializationContextProcessorsMessage[];
}
export interface ReactivatedSerializationContextProcessorsMessage {
  level_tag: "info" | "success" | "error" | "warning" | "debug";
  message: string;
  level: number;
  from_server: boolean;
}
export interface ReactivatedSerializationContextProcessorsCSRFProcessor {
  csrf_token: string;
}
export interface ReactivatedSerializationContextProcessorsRequestProcessor {
  request: ReactivatedSerializationContextProcessorsRequest;
}
export interface ReactivatedSerializationContextProcessorsRequest {
  path: string;
  url: string;
  csp_nonce: string | null;
}
export interface ReactivatedSerializationContextProcessorsStaticProcessor {
  STATIC_URL: string;
}
export interface ThelabuiContextProcessorsTranslationProcessor {
  i18n: ThelabuiContextProcessorsTranslationCatalog;
}
export interface ThelabuiContextProcessorsTranslationCatalog {
  language: ThelabuiTypesLanguage;
  catalog: ThelabuiContextProcessorsCatalogEntry[];
  formats: ThelabuiContextProcessorsFormatEntry[];
}
export interface ThelabuiContextProcessorsCatalogEntry {
  context: string;
  key: string;
  value: string | string[];
}
export interface ThelabuiContextProcessorsFormatEntry {
  key: string;
  value: string | number | string[];
}
export interface ServerCmsContextProcessorsCoreAssetProcessor {
  core_assets: ServerCmsContextProcessorsCoreAssets;
}
export interface ServerCmsContextProcessorsCoreAssets {
  favicon: string;
}
export interface ServerCmsContextProcessorsSettingsProcessor {
  ENVIRONMENT: string;
  SENTRY_DSN: string | null;
  CI_COMMIT_REF_SLUG: string;
  CI_COMMIT_SHA: string;
  ONETRUST_SCRIPT_UUID: string;
  GTM_CONTAINER_ID: string;
  GOOGLE_MAPS_API_KEY: string;
  RL_HEADER_SRC: string;
  RL_HEADER_UPDATED_ON: string | null;
  RL_HEADER_FETCHED_ON: string;
  RL_HEADER_CSS: string[];
  RL_HEADER_JS: string[];
  features: ServerCmsContextProcessorsFeatureFlags;
}
export interface ServerCmsContextProcessorsFeatureFlags {
  OLO_NEW_HEADER: boolean;
}
export interface ServerCmsContextProcessorsNavigationProcessor {
  header: HeaderSettingsBe415B7C0B | null;
  footer: FooterSettingsFf49Fdcb05 | null;
}
export interface HeaderSettingsBe415B7C0B {
  body: CmsHeaderSettings;
  map_page: LocationsPage_314E17C2B3 | null;
}
export interface CmsHeaderSettings {
  _type: "StreamField";
  _variant: "cms.HeaderSettings.body";
  value: HeaderBlock;
  [k: string]: unknown;
}
export interface NavSection {
  role: null | ("primary" | "secondary");
  links?: SimpleLinkBlockListOrNull;
}
export interface LocationsPage_314E17C2B3 {
  id: number;
  title: string;
  url: string;
}
export interface FooterSettingsFf49Fdcb05 {
  body: CmsFooterSettings;
}
export interface CmsFooterSettings {
  _type: "StreamField";
  _variant: "cms.FooterSettings.body";
  value: FooterBlock;
  [k: string]: unknown;
}
export interface FooterColumn {
  title: CharBlockOrNull;
  is_collapsable?: BooleanBlockOrNull;
  links: FooterColumnContentOrNull;
}
export interface RegionNav {
  regions: PageChooserBlock[];
}
export class RPC {
    constructor(public requester: rpcUtils.Requester) {
    }
}
export type UUID = `${string}-${string}-${string}-${string}-${string}`;

import type {Renderer as GenericRenderer} from "reactivated/dist/render.mjs";
export type Renderer = GenericRenderer<_Types["Context"]>;

export const rpc = new RPC(typeof window != "undefined" ? rpcUtils.defaultRequester : null as any);
import React from "react"
import * as generated from "reactivated/dist/generated";
import * as rpcUtils from "reactivated/dist/rpc";
import {constants} from "./constants";
export {constants};

export function classNames(...classes: (string | undefined | null | false)[]) {
    return classes.filter(Boolean).join(" ");
}

// Note: this needs strict function types to behave correctly with excess properties etc.
export type Checker<P, U extends (React.FunctionComponent<P> | React.ComponentClass<P>)> = {};

export type Result<TSuccess, TInvalid> = rpcUtils.Result<TSuccess, TInvalid, _Types["RPCPermission"]>;

export {Context} from "./context";
import {Context} from "./context";

import * as forms from "reactivated/dist/forms";
export type {FormHandler} from "reactivated/dist/forms";
export {reverse} from "./urls";

export const Provider = (props: {value: _Types["Context"]; children: React.ReactNode}) => {
    const [value, setValue] = React.useState(props.value);

    return (
        <Context.Provider value={{...value, setValue}}>
            {props.children}
        </Context.Provider>
    );
};

export const getServerData = () => {
    const props: Record<string, unknown> = (window as any).__PRELOADED_PROPS__;
    const context: _Types["Context"] = (window as any).__PRELOADED_CONTEXT__;

    return {props, context};
};

export type models = _Types["globals"]["models"];

export type {FieldHandler} from "./forms";
export {Form, FormSet, Widget, useForm, useFormSet, ManagementForm} from "reactivated/dist/forms";


import {Template as BasePageTemplateImplementation} from "@client/templates/BasePageTemplate"
export type BasePageTemplateCheck = Checker<_Types["BasePageTemplateProps"], typeof BasePageTemplateImplementation>;

export namespace templates {
    export type BasePageTemplate = _Types["BasePageTemplateProps"];
}


        



import {Template as BaseFormPageTemplateImplementation} from "@client/templates/BaseFormPageTemplate"
export type BaseFormPageTemplateCheck = Checker<_Types["BaseFormPageTemplateProps"], typeof BaseFormPageTemplateImplementation>;

export namespace templates {
    export type BaseFormPageTemplate = _Types["BaseFormPageTemplateProps"];
}


        



import {Template as BaseFormPageLandingPageTemplateImplementation} from "@client/templates/BaseFormPageLandingPageTemplate"
export type BaseFormPageLandingPageTemplateCheck = Checker<_Types["BaseFormPageLandingPageTemplateProps"], typeof BaseFormPageLandingPageTemplateImplementation>;

export namespace templates {
    export type BaseFormPageLandingPageTemplate = _Types["BaseFormPageLandingPageTemplateProps"];
}


        



import {Template as ExamplePageTemplateImplementation} from "@client/templates/ExamplePageTemplate"
export type ExamplePageTemplateCheck = Checker<_Types["ExamplePageTemplateProps"], typeof ExamplePageTemplateImplementation>;

export namespace templates {
    export type ExamplePageTemplate = _Types["ExamplePageTemplateProps"];
}


        



import {Template as LabUIToolboxSnippetPreviewImplementation} from "@client/templates/LabUIToolboxSnippetPreview"
export type LabUIToolboxSnippetPreviewCheck = Checker<_Types["LabUIToolboxSnippetPreviewProps"], typeof LabUIToolboxSnippetPreviewImplementation>;

export namespace templates {
    export type LabUIToolboxSnippetPreview = _Types["LabUIToolboxSnippetPreviewProps"];
}


        



import {Template as ContactUsPageTemplateImplementation} from "@client/templates/ContactUsPageTemplate"
export type ContactUsPageTemplateCheck = Checker<_Types["ContactUsPageTemplateProps"], typeof ContactUsPageTemplateImplementation>;

export namespace templates {
    export type ContactUsPageTemplate = _Types["ContactUsPageTemplateProps"];
}


        



import {Template as ContactUsPageLandingPageTemplateImplementation} from "@client/templates/ContactUsPageLandingPageTemplate"
export type ContactUsPageLandingPageTemplateCheck = Checker<_Types["ContactUsPageLandingPageTemplateProps"], typeof ContactUsPageLandingPageTemplateImplementation>;

export namespace templates {
    export type ContactUsPageLandingPageTemplate = _Types["ContactUsPageLandingPageTemplateProps"];
}


        



import {Template as LocationsPageMapTemplateImplementation} from "@client/templates/LocationsPageMapTemplate"
export type LocationsPageMapTemplateCheck = Checker<_Types["LocationsPageMapTemplateProps"], typeof LocationsPageMapTemplateImplementation>;

export namespace templates {
    export type LocationsPageMapTemplate = _Types["LocationsPageMapTemplateProps"];
}


        



import {Template as EmailSignupPageTemplateImplementation} from "@client/templates/EmailSignupPageTemplate"
export type EmailSignupPageTemplateCheck = Checker<_Types["EmailSignupPageTemplateProps"], typeof EmailSignupPageTemplateImplementation>;

export namespace templates {
    export type EmailSignupPageTemplate = _Types["EmailSignupPageTemplateProps"];
}


        



import {Template as EmailSignupPageLandingPageTemplateImplementation} from "@client/templates/EmailSignupPageLandingPageTemplate"
export type EmailSignupPageLandingPageTemplateCheck = Checker<_Types["EmailSignupPageLandingPageTemplateProps"], typeof EmailSignupPageLandingPageTemplateImplementation>;

export namespace templates {
    export type EmailSignupPageLandingPageTemplate = _Types["EmailSignupPageLandingPageTemplateProps"];
}


        



import {Template as HomePageTemplateImplementation} from "@client/templates/HomePageTemplate"
export type HomePageTemplateCheck = Checker<_Types["HomePageTemplateProps"], typeof HomePageTemplateImplementation>;

export namespace templates {
    export type HomePageTemplate = _Types["HomePageTemplateProps"];
}


        



import {Template as LocationsPageStateListTemplateImplementation} from "@client/templates/LocationsPageStateListTemplate"
export type LocationsPageStateListTemplateCheck = Checker<_Types["LocationsPageStateListTemplateProps"], typeof LocationsPageStateListTemplateImplementation>;

export namespace templates {
    export type LocationsPageStateListTemplate = _Types["LocationsPageStateListTemplateProps"];
}


        



import {Template as LocationsPageLocationListTemplateImplementation} from "@client/templates/LocationsPageLocationListTemplate"
export type LocationsPageLocationListTemplateCheck = Checker<_Types["LocationsPageLocationListTemplateProps"], typeof LocationsPageLocationListTemplateImplementation>;

export namespace templates {
    export type LocationsPageLocationListTemplate = _Types["LocationsPageLocationListTemplateProps"];
}


        



import {Template as LocationsPageLocationTemplateImplementation} from "@client/templates/LocationsPageLocationTemplate"
export type LocationsPageLocationTemplateCheck = Checker<_Types["LocationsPageLocationTemplateProps"], typeof LocationsPageLocationTemplateImplementation>;

export namespace templates {
    export type LocationsPageLocationTemplate = _Types["LocationsPageLocationTemplateProps"];
}


        



import {Template as PressReleasePageTemplateImplementation} from "@client/templates/PressReleasePageTemplate"
export type PressReleasePageTemplateCheck = Checker<_Types["PressReleasePageTemplateProps"], typeof PressReleasePageTemplateImplementation>;

export namespace templates {
    export type PressReleasePageTemplate = _Types["PressReleasePageTemplateProps"];
}


        



import {Template as PressReleaseListPageTemplateImplementation} from "@client/templates/PressReleaseListPageTemplate"
export type PressReleaseListPageTemplateCheck = Checker<_Types["PressReleaseListPageTemplateProps"], typeof PressReleaseListPageTemplateImplementation>;

export namespace templates {
    export type PressReleaseListPageTemplate = _Types["PressReleaseListPageTemplateProps"];
}


        



import {Template as PressSectionPageTemplateImplementation} from "@client/templates/PressSectionPageTemplate"
export type PressSectionPageTemplateCheck = Checker<_Types["PressSectionPageTemplateProps"], typeof PressSectionPageTemplateImplementation>;

export namespace templates {
    export type PressSectionPageTemplate = _Types["PressSectionPageTemplateProps"];
}


        



import {Template as RedirectPageTemplateImplementation} from "@client/templates/RedirectPageTemplate"
export type RedirectPageTemplateCheck = Checker<_Types["RedirectPageTemplateProps"], typeof RedirectPageTemplateImplementation>;

export namespace templates {
    export type RedirectPageTemplate = _Types["RedirectPageTemplateProps"];
}


        



import {Template as UtilityPageTemplateImplementation} from "@client/templates/UtilityPageTemplate"
export type UtilityPageTemplateCheck = Checker<_Types["UtilityPageTemplateProps"], typeof UtilityPageTemplateImplementation>;

export namespace templates {
    export type UtilityPageTemplate = _Types["UtilityPageTemplateProps"];
}


        



import {Template as LabUIIncludeReactContextTemplateImplementation} from "@client/templates/LabUIIncludeReactContextTemplate"
export type LabUIIncludeReactContextTemplateCheck = Checker<_Types["LabUIIncludeReactContextTemplateProps"], typeof LabUIIncludeReactContextTemplateImplementation>;

export namespace templates {
    export type LabUIIncludeReactContextTemplate = _Types["LabUIIncludeReactContextTemplateProps"];
}


        



import {Template as FooterTemplateImplementation} from "@client/templates/FooterTemplate"
export type FooterTemplateCheck = Checker<_Types["FooterTemplateProps"], typeof FooterTemplateImplementation>;

export namespace templates {
    export type FooterTemplate = _Types["FooterTemplateProps"];
}


        



import {Template as Error404TemplateImplementation} from "@client/templates/Error404Template"
export type Error404TemplateCheck = Checker<_Types["Error404TemplateProps"], typeof Error404TemplateImplementation>;

export namespace templates {
    export type Error404Template = _Types["Error404TemplateProps"];
}


        
export {Iterator, CSRFToken, createRenderer} from "./forms";
export {getTemplate} from "./template";

